import React from "react";
import {
  ShoppingCart,
  Phone,
  Package,
  CheckCircle2,
  ArrowRight,
  Truck,
  Warehouse,
  Boxes,
  Landmark
} from "lucide-react";
import { Link } from "react-router-dom";

// const trackingStages = [
//   { label: "Booking\nConfirmed", icon: CheckCircle2 },
//   { label: "Picked Up", icon: Package },
//   { label: "In Transit", icon: Truck },
//   { label: "Arrived Hub", icon: Warehouse },
//   { label: "Out for Delivery", icon: Truck },
//   { label: "Delivered", icon: HomeIcon },
// ];

const products = [
  {
    icon: Boxes,
    title: "Logistics Solutions",
    body: "End-to-end freight planning and route management for businesses.",
    url: "/services#logistics-solutions",
  },
  {
    icon: ShoppingCart,
    title: "E-Commerce Logistics",
    body: "Pick, pack, and last-mile delivery built for high-volume online sellers.",
    url: "/services#ecommerce-logistics",
  },
  {
    icon: Warehouse,
    title: "Warehousing Solutions",
    body: "Secure, scalable storage with real-time inventory visibility.",
    url: "/services#warehousing-solutions",
  },
  {
    icon: Landmark,
    title: "Government Project Deliveries",
    body: "Compliant, on-schedule delivery for public sector  projects.",
    url: "/services#government-project-deliveries",
  },
];

const steps = [
  {
    icon: Phone,
    title: "Share Your Shipment",
    body: "Tell us dimensions, origin, and destination for an instant rate.",
  },
  {
    icon: Package,
    title: "Lock Your Slot",
    body: "Compare available line-hauls and reserve your cargo space.",
  },
  {
    icon: Truck,
    title: "Ride The Route",
    body: "Secure handling and priority road transport, tracked end to end.",
  },
  {
    icon: CheckCircle2,
    title: "Doorstep Drop-Off",
    body: "Smooth clearance and confirmed hand-delivery at the destination.",
  },
];

function TrackingCard() {
  return (
    <div className="hero-img-section">
      <img src="./img/hero-img.webp" alt="" />
    </div>
  );
}

function Hero() {
  return (
    <section className="rx-hero">
      <div className="rx-hero-grid">
        <div>
          <div className="rx-eyebrow">FREIGHT SOLUTION PROVIDER</div>
          <h1>
            Nationwide
            <br />
            <span className="accent">Door-to-Door</span>
            <br />
            Express Delivery
          </h1>
          <p className="rx-lead">
            Reliable Express keeps your shipping pipeline moving - fast road
            departures, true door-to-door fulfilment, and dedicated support
            from pickup to proof of delivery.
          </p>
          <div className="rx-tag-row">
            {["Logistics", "E-Commerce", "Warehouse", "Government Project"].map((t) => (
              <span className="rx-tag" key={t}>
                {t}
              </span>
            ))}
          </div>
          <div className="rx-btn-row">
            <Link to="/contact"><button className="rx-btn-primary">
              Get Quote Now <ArrowRight size={16} />
            </button></Link>
            <Link to="/about"><button className="rx-btn-outline">Learn More</button></Link>
          </div>
        </div>
        <TrackingCard />
      </div>
    </section>
  );
}

function DoorToDoor() {
  return (
    <section className="rx-d2d">
      <div className="rx-d2d-grid">
        <div className="rx-d2d-art">
          <img src="./img/about-img.webp" alt="" />
        </div>
                <div>
          <div className="rx-section-eyebrow">About Us</div>
          <h2>
            Moving Business Forward with Reliable Logistics
          </h2>
          <p className="rx-lead">
            At Reliable Express, we provide dependable logistics and transportation solutions designed to keep businesses moving. From freight transportation and e-commerce deliveries to warehousing and government projects, we offer efficient solutions tailored to every requirement.
          </p>
          <Link to="/about"><button className="rx-btn-dark">
            Know More <ArrowRight size={16} />
          </button></Link>
        </div>
      </div>
    </section>
  );
}

function ProductOffering() {
  return (
    <section className="rx-offering">
      <div className="rx-offering-inner">
        <div className="rx-section-head">
          <h2>Services Offering</h2>
          <p>Tailored freight solutions built around speed, absolute reliability, and nationwide reach.</p>
        </div>
        <div className="rx-cards-grid">
          {products.map((p, i) => {
            const Icon = p.icon;
            return (
              <div className="rx-product-card" key={i}>
                <div className={`rx-product-icon ${i % 2 !== 0 ? "alt" : ""}`}>
                  <Icon size={20} />
                </div>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
                <Link className="rx-link" to={p.url}>
                  Learn More <ArrowRight size={13} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function HowItWorks() {
  return (
    <section className="rx-how">
      <div className="rx-how-inner">
        <div className="rx-section-head">
          <h2>How It Works</h2>
          <p>We guide your cargo smoothly from quote filing to final destination release.</p>
        </div>
        <div className="rx-steps-wrap">
          <div className="rx-steps-line" />
          <div className="rx-cards-grid">
            {steps.map((s, i) => {
              const Icon = s.icon;
              const isFinal = i === steps.length - 1;
              return (
                <div className="rx-step" key={i}>
                  <div className={`rx-step-icon ${isFinal ? "final" : ""}`}>
                    <Icon size={22} />
                  </div>
                  <div className="rx-step-label">STEP 0{i + 1}</div>
                  <h3>{s.title}</h3>
                  <p>{s.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="rx-cta">
      
      <div className="rx-cta-inner">
        <h2>Get Started Today</h2>
        <p>
          Contact our logistics experts today and get the best freight rates
          and custom delivery blueprints for your business.
        </p>
        <Link to="/contact"><button className="rx-btn-cta">Get Free Quote</button></Link>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Hero />
      <DoorToDoor />
      <ProductOffering />
      <HowItWorks />
      <CTA />
    </>
  );
}
